const CUSTOM_ATTRIBUTE_FINISHED_LOADING = 'data-loaded';

const addListeners = (element: HTMLScriptElement, onLoad: () => void, onError: (reason?: Event) => void) => {
  const loadListener = () => onLoad();
  const errorListener = (e: Event) => onError(e);
  const abortListener = (e: UIEvent) => onError(e);
  element.addEventListener('load', loadListener);
  element.addEventListener('error', errorListener);
  element.addEventListener('abort', abortListener);
};

export function loadScript(url: string): Promise<void> {
  const existingScriptElement = document.querySelector(`script[src="${url}"]`) as HTMLScriptElement | undefined;

  if (existingScriptElement) {
    if (existingScriptElement.getAttribute(CUSTOM_ATTRIBUTE_FINISHED_LOADING)) {
      return new Promise<void>((resolve) => resolve());
    }

    return new Promise<void>((resolve, reject) => {
      addListeners(existingScriptElement, resolve, reject);
    });
  }

  return new Promise<void>((resolve, reject) => {
    const scriptElement = document.createElement('script');
    const onLoad = () => {
      scriptElement.setAttribute(CUSTOM_ATTRIBUTE_FINISHED_LOADING, '1');
      resolve();
    };
    addListeners(scriptElement, onLoad, reject);
    scriptElement.fetchPriority = 'high';
    scriptElement.src = url;
    document.body.appendChild(scriptElement);
  });
}
